import com.starparty.app.astro0.SP_Place
import com.starparty.app.astro0.SP_Time
import com.starparty.app.astro0.Sky
import com.starparty.app.astro0.js.*
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.HTMLCanvasElement
import org.w3c.dom.HTMLMetaElement
import org.w3c.dom.get
import org.w3c.dom.url.URLSearchParams
import kotlin.js.Date
import kotlin.math.absoluteValue


// Greenwich Royal Observatory
// val DEF_LATITUDE: Double = 51.476853
// val DEF_LONGITUDE: Double = -5.002E-4

// Sennen Cove
// val DEF_LATITUDE: Double = UMS.Companion.unitMinSecToDecimal("50 4 40")
// val DEF_LONGITUDE: Double = UMS.Companion.unitMinSecToDecimal("-5 42 12")

//    val DEF_LATITUDE: Double = UMS.Companion.unitMinSecToDecimal("51 0 0")
//    val DEF_LONGITUDE: Double = UMS.Companion.unitMinSecToDecimal("0 0 0")


const val VERSION = "3.40"
val copyrightDates = setCopyrightDates()
const val MORE_INFO_WEBPAGE = "https://starparty.com/"

val DEF_LATITUDE: Double = 51.476853
val DEF_LONGITUDE: Double = -1.2278

var urlParams = params()
var timeZoneOffsetHours = 0
var timeZoneOffsetMins = 0
var dateTime = initialiseDateTime()
var latLong = initialisePlace()
val sky = Sky(dateTime, latLong)
val spCanvas = initalizeCanvas()
val skyViewCS = SP_JSSkyViewCanvasState(sky, spCanvas).apply {
}

private val clock = SP_JSClock(window)
val controls = SP_JSControls(sky, skyViewCS, clock)


fun params() : URLSearchParams {

    val url = window.location.search
    val params = URLSearchParams(url)

    return params
}

fun setCopyrightDates(): String {
    var dates = "2020-"
    val currentYear = Date().getFullYear()

    return dates + currentYear
}

fun initialisePlace(): SP_Place
{
    val latLong = SP_Place(DEF_LATITUDE, DEF_LONGITUDE)

    val latParam = urlParams.get("lat")
    val lat = latParam.toString().toDoubleOrNull()

    val lonParam = urlParams.get("lon")
    val lon = lonParam.toString().toDoubleOrNull()

    if (null != lat)
    {
        latLong.latitude = lat
    }

    if (null != lon)
    {
        latLong.longitude = lon
    }

    return latLong
}

fun initialiseDateTime(): SP_Time {

    val nowUTC = Date.now()
    val nowSPTime = createTime(nowUTC)

    initialiseTimeZoneOffset()

    return nowSPTime
}

fun createTime(timeStamp: Double): SP_Time {
    val date = Date(timeStamp)
    val year = date.getUTCFullYear()
    val month = date.getUTCMonth() // zero indexed Jan=0
    val day = date.getUTCDate()
    val hour = date.getUTCHours()
    val min = date.getUTCMinutes()
    val sec = date.getUTCSeconds()
    val ms = date.getUTCMilliseconds()
    //  console.log("utcms:$nowUTC,$year, $month, $day, $hour, $min, $sec")

    return SP_JSTime(year, month + 1, day, hour, min, sec, ms)
}

fun toTimeStamp(spt: SP_Time):Double {
    val ts = Date.UTC(spt.yearUTC(),
                      spt.monthUTC() - 1,
                      spt.dayOfMonthUTC(),
                      spt.hourOfDayUTC(),
                      spt.minuteUTC(),
                      spt.secondUTC(),
                      spt.millisecondUTC())

    return ts
}

fun initialiseTimeZoneOffset() {

    val tzoParam = urlParams.get("tzo")
    val tzoMins = tzoParam.toString().toDoubleOrNull()

    if (null != tzoMins) {

        val tzo = tzoMins / 60.0
        if (tzo >= -14.0 && tzo <=14.0 ) {
            timeZoneOffsetHours = tzo.toInt()
            timeZoneOffsetMins = ((tzo - timeZoneOffsetHours).absoluteValue * 60.0).toInt()

            if (timeZoneOffsetMins != 15 &&
                timeZoneOffsetMins != 30 &&
                timeZoneOffsetMins != 45 ) {

                timeZoneOffsetMins = 0
            }
        }
    }
}

fun initalizeCanvas(): SP_JSCanvas {

    val htmlCanvas = document.createElement("canvas") as HTMLCanvasElement
    val spCanvas = SP_JSCanvas(htmlCanvas)

    return spCanvas
}

/*fun setupKeyboard(){
    window.onload = {
        document.onkeypress = { e: KeyboardEvent ->

            if (e.keyCode == 33) { // Pageup
                console.log("Page up ")
            }
            if (e.keyCode == 34) { // Pagedown
console.log("Page down ")
            }
            Unit
        }
        Unit
    }
}*/

fun main(args: Array<String>) {

    var spData = ""

    try {
        val spDataElement = document.getElementsByName("starparty-data").get(0) as HTMLMetaElement
        spData = spDataElement.content
    }
    catch(e:Exception) {}

    val hideLocationControls = spData.contains("hide-location-controls")

    controls.setupAboutButton()
    controls.setupHelpButton()
    controls.setupDateTimeControls(timeZoneOffsetHours, timeZoneOffsetMins)
    if ( ! hideLocationControls) {
        controls.setupLocationSpinners()
    }

    controls.setupZoomButtons()
    controls.setupRotateButtons()

    controls.setupDirectionButtons()
    controls.setupShowButtons()

    controls.setupSearchBox()

    controls.setupCanvas()

    clock.addTimeListener(controls)
    clock.start(sky.getTime())
}
